import {
  BrowserCacheLocation,
  Configuration,
  LogLevel,
  RedirectRequest
} from '@azure/msal-browser';
import { aggregator } from '@env/aggregator/aggregator';

import { environment } from '@env/environment';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

const authority = `https://${aggregator.settings.auth.domain}/${environment.sparkPlusB2CTenant}.onmicrosoft.com/${environment.sparkPlusB2CUserFlow}`;

export const b2cPolicies = {
  names: {
    signUpSignIn: environment.sparkPlusB2CUserFlow
  },
  authorities: {
    signUpSignIn: {
      authority: authority
    }
  },
  authorityDomain: aggregator.settings.auth.domain
};

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.sparkPlusApplicationId, // This is the ONLY mandatory field that you need to supply.
    authority: b2cPolicies.authorities.signUpSignIn.authority, // Defaults to "https://login.microsoftonline.com/common"
    knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
    redirectUri: `${window.location.origin}/redirect-app`,
    postLogoutRedirectUri: '/'
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: isIE // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        console.log(message);
      },
      logLevel: environment.production ? LogLevel.Error : LogLevel.Warning,
      piiLoggingEnabled: false
    },
    iframeHashTimeout: 35000 //Increase timeout to allow B2C to redirect user back to spark plus without having a monitor_window_timeout error.
  }
};

export const protectedResources = {
  opportunityApi: {
    endpoint: environment.opportunityApiUrl,
    scopes: environment.opportunityApiScopes
  },
  clientsApi: {
    endpoint: environment.clientsApiUrl,
    scopes: environment.clientsApiScopes
  },
  managementApi: {
    endpoint: environment.managementApiUrl,
    scopes: environment.managementApiScopes
  },
  documentApi: {
    endpoint: environment.opportunityDocumentApiUrl,
    scopes: environment.opportunityDocumentApiScopes
  },
  iqAuthApi: {
    endpoint: environment.iqAuthApiUrl,
    scopes: environment.iqAuthApiScopes
  },
  libraryApi: {
    endpoint: environment.libraryApiUrl,
    scopes: environment.libraryApiScopes
  },
};

export const loginRequest: RedirectRequest = {
  scopes: protectedResources.opportunityApi.scopes,
  state: window.location.href,
  extraQueryParameters: {
    aggregator: aggregator.name
  }
};
